// src/utils/boards.ts
import { collection, doc, setDoc, Timestamp } from "firebase/firestore";
import { db } from "./firebase"; // adjust the import path to your firebase initialization

// --------------------
// Type Definitions
// --------------------

export interface Picture {
  id: string;
  url: string;
  reference: string; // URL of the creator’s site
  createdAt: Timestamp;
}

// We now define a board as having multiple pictures and a thumbnail.
export interface Board {
  id: string;
  pictures: Picture[];
  title?: string;
  thumbnail: string;
  createdAt: Timestamp;
}

// We expect to receive board data without the generated fields "id" and "createdAt"
export type NewBoardData = Omit<Board, "id" | "createdAt">;

export async function createBoard(
  userId: string,
  boardData: NewBoardData
): Promise<string> {
  try {
    // Reference the subcollection for boards belonging to the user.
    const boardsCollectionRef = collection(db, "users", userId, "boards");

    // Create a new document reference with an auto‑generated id.
    const newBoardDocRef = doc(boardsCollectionRef);

    // Build the complete board object with the generated id and the current timestamp.
    const board: Board = {
      id: newBoardDocRef.id,
      ...boardData,
      createdAt: Timestamp.now(),
    };

    // Write the new board document to Firestore.
    await setDoc(newBoardDocRef, board);

    return newBoardDocRef.id;
  } catch (error) {
    console.error("Error creating board:", error);
    throw error;
  }
}
